// Unpublished Work © 2022 Deere & Company

import t from 'tcomb';
import {AddressLabels} from './address-labels';
import {EmailLabel} from './email-label';

export const CommunicationLabels = t.struct({
    email: EmailLabel,
    homeFax: t.String,
    homePhone: t.String,
    mailingAddress: AddressLabels,
    mobilePhone: t.String,
    physicalAddress: AddressLabels,
    workFax: t.String,
    workPhone: t.String
}, {
    defaultProps: {
        email: new EmailLabel({}),
        homeFax: '',
        homePhone: '',
        mailingAddress: new AddressLabels({}),
        mobilePhone: '',
        physicalAddress: new AddressLabels({}),
        workFax: '',
        workPhone: ''
    },
    name: 'CommunicationLabels'
});
